/**
 * Tooltip Component
 * 
 * Displays status messages when hovering over states on the map.
 * Positioned near the cursor with a dark background and white text.
 */

import React from 'react';

export function Tooltip({ message, position }) {
  if (!message || !position) {
    return null;
  }

  const style = {
    position: 'fixed',
    left: `${position.x + 10}px`,
    top: `${position.y + 10}px`,
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    color: '#ffffff',
    padding: '8px 12px',
    borderRadius: '4px',
    fontSize: '14px',
    pointerEvents: 'none',
    zIndex: 1000,
    whiteSpace: 'nowrap',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif'
  };

  return (
    <div className="map-tooltip" style={style} role="tooltip">
      {message}
    </div>
  );
}
